//  Tab list code has been re written - 12-11-24 - Dev Srini

import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

import { Tabs, Tab, Grid, useMediaQuery } from '@material-ui/core' // Srini 07-01-25
import { withStyles } from '@material-ui/core/styles'
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import styles from './listTabStyles'
import { useNavigate } from 'react-router-dom';

import check from '../../../../ui-assets/check.svg'

const ListTabs = ({ classes }) => {
    const isSmallScreen = useMediaQuery('(max-width: 600px)') // Srini 07-01-25
    const user_data = JSON.parse(localStorage.getItem("sipRegData"))
    console.log("userData",user_data)
    const navigate=useNavigate()

    // const agentRole = JSON.parse(localStorage.getItem('agentRole')) 
    // const agentMenu = JSON.parse(localStorage.getItem('agentMenu')) 
    // const departmentName = localStorage.getItem('departmentName') 
    const [selectedTab, setSelectedTab] = useState(0)

    useEffect(() => {
        setSelectedTab(0)
        navigate("/incomplete-kyc")
    }, [])

    const handleTabChange = (tabName) => {
        setSelectedTab(tabName)
    }

    return (
        <Grid>
            <Tabs
                orientation="vertical"
                variant="scrollable"
                value={selectedTab}
                onChange={handleTabChange}
                classes={{ indicator: classes.indicator }}
                className={classes.verticalTabLayout}
                style={{ flexDirection: 'column', alignItems: 'flex-start' }}
            >
                {/** Dashboard Tab  Srini 07-01-25 */}
                
              {/* {!isSmallScreen && (<Tab
                    component={Link}
                    to="/dashboard"
                    label={
                        <Grid
                            container
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '20px' }}
                        >
                            <img src={check} alt='dashboard' style={{ width: '24px', height: '24px', flexShrink: 0 }} />
                            <span style={{ color: 'white', textTransform: 'none' }}>Dashboard</span>
                        </Grid>
                    }
                    value={0} // srini - 21/11/24
                    onClick={() => setSelectedTab(0)}
                    style={{
                        marginTop: '85px',
                        display: 'flex',
                        alignItems: 'center',
                        textDecoration: 'none',
                        position: 'relative',
                        backgroundColor: selectedTab === 0 ? '##3C215A' : '',
                        textTransform: 'none',
                        width: '200px',
                        height: '50px',
                        paddingLeft: '30px'
                    }}
                />)} */}




                {(!isSmallScreen && user_data?.roles?.[0]?.menus?.some(menu => menu.name === 'incompleteKYC')) && (<Tab
                    component={Link}
                    to="/incomplete-kyc"
                    label={
                        <Grid
                            container
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '20px' }}
                        >
                            <img src={check} alt='incomplete-kyc' style={{ width: '24px', height: '24px', flexShrink: 0 }} />
                            <span style={{ color: 'white', textTransform: 'none' }}>KYC</span>
                        </Grid>
                    }
                    value={0} // srini - 21/11/24
                    onClick={() => setSelectedTab(0)}
                    style={{
                        marginTop: '85px',
                        display: 'flex',
                        alignItems: 'center',
                        textDecoration: 'none',
                        position: 'relative',
                        backgroundColor: selectedTab === 0 ? '#1E0F36' : '',
                        textTransform: 'none',
                        width: '200px',
                        height: '50px',
                        paddingLeft: '30px'

                    }}
                />)}



                {(!isSmallScreen && user_data?.roles?.[0]?.menus?.some(menu => menu.name === 'Department') || !isSmallScreen && user_data?.additionalMenu?.some(menu => menu.name === 'Department')) && (
                    <Tab
                        component={Link}
                        to="/department"
                        label={
                            <Grid
                                container
                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '20px' }}
                            >
                                <img src={check} alt='department' style={{ width: '24px', height: '24px', flexShrink: 0 }} />
                                <span style={{ color: 'white', textTransform: 'none' }}>Department</span>
                            </Grid>
                        }
                        value={1} // srini - 21/11/24
                        onClick={() => setSelectedTab(1)}
                        style={{
                            marginTop: '2px',
                            display: 'flex',
                            alignItems: 'center',
                            textDecoration: 'none',
                            position: 'relative',
                            backgroundColor: selectedTab === 1 ? 'black' : '',
                            textTransform: 'none',
                            width: '200px',
                            height: '50px',
                            paddingLeft: '30px'
                        }}
                    />
                )}

                {(!isSmallScreen && user_data?.roles?.[0]?.menus?.some(menu => menu.name === 'Roles') || !isSmallScreen && user_data?.additionalMenu?.some(menu => menu.name === 'Roles')) && (
                    <Tab
                        component={Link}
                        to="/roles"
                        label={
                            <Grid
                                container
                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '20px' }}
                            >
                                <img src={check} alt='roles' style={{ width: '24px', height: '24px', flexShrink: 0 }} />
                                <span style={{ color: 'white', textTransform: 'none' }}>Roles</span>
                            </Grid>
                        }
                        value={2} // srini - 21/11/24
                        onClick={() => setSelectedTab(2)}
                        style={{
                            marginTop: '2px',
                            display: 'flex',
                            alignItems: 'center',
                            textDecoration: 'none',
                            position: 'relative',
                            backgroundColor: selectedTab === 2 ? 'black' : '',
                            textTransform: 'none',
                            width: '200px',
                            height: '50px',
                            paddingLeft: '30px'

                        }}
                    />
                )}






                {(!isSmallScreen && user_data?.roles?.[0]?.menus?.some(menu => menu.name === 'Users') || !isSmallScreen && user_data?.additionalMenu?.some(menu => menu.name === 'Users')) && (
                    <Tab
                        component={Link}
                        to="/users"
                        label={
                            <Grid
                                container
                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '20px' }}
                            >
                                <img src={check} alt='users' style={{ width: '24px', height: '24px', flexShrink: 0 }} />
                                <span style={{ color: 'white', textTransform: 'none' }}>Users</span>
                            </Grid>
                        }
                        value={8} // srini - 21/11/24
                        onClick={() => setSelectedTab(8)}
                        style={{
                            marginTop: '2px',
                            display: 'flex',
                            alignItems: 'center',
                            textDecoration: 'none',
                            position: 'relative',
                            backgroundColor: selectedTab === 8 ? 'black' : '',
                            textTransform: 'none',
                            width: '200px',
                            height: '50px',
                            paddingLeft: '30px'
                        }}
                    />
                )}





                {(!isSmallScreen && user_data?.roles?.[0]?.menus?.some(menu => menu.name === 'Tickets')) &&
                    <Tab
                        component={Link}
                        to="/ticket"
                        label={
                            <Grid
                                container
                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '20px' }}
                            >
                                <img src={check} alt='department' style={{ width: '24px', height: '24px', flexShrink: 0 }} />
                                <span style={{ color: 'white', textTransform: 'none' }}>Tickets</span>
                            </Grid>
                        }
                        value={3} // srini - 21/11/24
                        onClick={() => setSelectedTab(3)}
                        style={{
                            marginTop: '2px',
                            display: 'flex',
                            alignItems: 'center',
                            textDecoration: 'none',
                            position: 'relative',
                            backgroundColor: selectedTab === 3 ? 'black' : '',
                            textTransform: 'none',
                            width: '200px',
                            height: '50px',
                            paddingLeft: '30px'
                        }}
                    />
                }


                {(!isSmallScreen && user_data?.roles?.[0]?.menus?.some(menu => menu.name === 'Service')) &&
                    <Tab
                        component={Link}
                        to="/servicecase"
                        label={
                            <Grid
                                container
                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '20px' }}
                            >
                                <img src={check} alt='department' style={{ width: '24px', height: '24px', flexShrink: 0 }} />
                                <span style={{ color: 'white', textTransform: 'none' }}>Service Case</span>
                            </Grid>
                        }
                        value={4} // srini - 21/11/24
                        onClick={() => setSelectedTab(4)}
                        style={{
                            marginTop: '2px',
                            display: 'flex',
                            alignItems: 'center',
                            textDecoration: 'none',
                            position: 'relative',
                            backgroundColor: selectedTab === 4 ? 'black' : '',
                            textTransform: 'none',
                            width: '200px',
                            height: '50px',
                            paddingLeft: '30px'
                        }}
                    />
                }

                {(!isSmallScreen && user_data?.roles?.[0]?.menus?.some(menu => menu.name === 'Franchisee')) && 
                    <Tab
                        component={Link}
                        to="/franchise"
                        label={
                            <Grid
                                container
                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '20px' }}
                            >
                                <img src={check} alt='social-campaign' style={{ width: '24px', height: '24px', flexShrink: 0 }} />
                                <span style={{ color: 'white', textTransform: 'none' }}>Franchise</span>
                            </Grid>
                        }
                        value={5}
                        onClick={() => setSelectedTab(5)}
                        style={{
                            marginTop: '2px',
                            display: 'flex',
                            alignItems: 'center',
                            textDecoration: 'none',
                            position: 'relative',
                            backgroundColor: selectedTab === 5 ? 'black' : '',
                            textTransform: 'none',
                            width: '200px',
                            height: '50px',
                            paddingLeft: '30px'
                        }}
                    />
                }



                {(!isSmallScreen && user_data?.roles?.[0]?.menus?.some(menu => menu.name === 'Blogs') || !isSmallScreen && user_data?.additionalMenu?.some(menu => menu.name === 'Blogs')) && (<Tab
                    component={Link}
                    to="/blogs"
                    label={
                        <Grid
                            container
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '20px' }}
                        >
                            <img src={check} alt='franchisedashboard' style={{ width: '24px', height: '24px', flexShrink: 0 }} />
                            <span style={{ color: 'white', textTransform: 'none' }}>Blogs</span>
                        </Grid>
                    }
                    value={6}
                    onClick={() => setSelectedTab(6)}
                    style={{
                        marginTop: '2px',
                        display: 'flex',
                        alignItems: 'center',
                        textDecoration: 'none',
                        position: 'relative',
                        backgroundColor: selectedTab === 6 ? 'black' : '',
                        textTransform: 'none',
                        width: '200px',
                        height: '50px',
                        paddingLeft: '30px'
                    }}
                />)}





               
             
                {/* {!isSmallScreen && [1, 3].some(role => agentRole.includes(role)) && (<Tab
                    component={Link}
                    to="/social-campaign"
                    label={
                        <Grid
                            container
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '20px' }}
                        >
                            <img src={check} alt='social-campaign' style={{ width: '24px', height: '24px', flexShrink: 0 }} />
                            <span style={{ color: 'white', textTransform: 'none' }}>Social Campaign</span>
                        </Grid>
                    }
                    value={5} // srini - 21/11/24
                    onClick={() => setSelectedTab(5)}
                    style={{
                        marginTop: '2px',
                        display: 'flex',
                        alignItems: 'center',
                        textDecoration: 'none',
                        position: 'relative',
                        backgroundColor: selectedTab === 5 ? 'black' : '',
                        textTransform: 'none',
                        width: '200px',
                        height: '50px',
                        paddingLeft: '30px'
                    }}
                />)}
             
                {!isSmallScreen && [1, 3].some(role => agentRole.includes(role)) && (
                    <Tab
                        component={Link}
                        to="/monitoring"
                        label={
                            <Grid
                                container
                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '20px' }}
                            >
                                <img src={check} alt='monitoring' style={{ width: '24px', height: '24px', flexShrink: 0 }} />
                                <span style={{ color: 'white', textTransform: 'none' }}>Monitoring</span>
                            </Grid>
                        }
                        value={6}
                        onClick={() => setSelectedTab(6)}
                        style={{
                            marginTop: '2px',
                            display: 'flex',
                            alignItems: 'center',
                            textDecoration: 'none',
                            position: 'relative',
                            backgroundColor: selectedTab === 6 ? 'black' : '',
                            textTransform: 'none',
                            width: '200px',
                            height: '50px',
                            paddingLeft: '30px'
                        }}
                    />
                )}

              
                {!isSmallScreen && (([1, 2].some(role => agentRole.includes(role)) && agentMenu.includes(5)) || agentRole.includes(3)) && <Tab
                    component={Link}
                    to="/whatsapp"
                    label={
                        <Grid
                            container
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '20px' }}
                        >
                            <WhatsAppIcon sx={{ color: "white", fontSize: "22px" }} />
                            <span style={{ color: 'white', textTransform: 'none' }}>Whatsapp</span>
                        </Grid>
                    }
                    value={7} // srini - 21/11/24
                    onClick={() => setSelectedTab(7)}
                    style={{
                        marginTop: '2px',
                        display: 'flex',
                        alignItems: 'center',
                        textDecoration: 'none',
                        position: 'relative',
                        backgroundColor: selectedTab === 7 ? 'black' : '',
                        textTransform: 'none',
                        width: '200px',
                        height: '50px',
                        paddingLeft: '30px'
                    }}
                />}
            
             
                {!isSmallScreen && [1, 3].some(role => agentRole.includes(role)) && <Tab
                    component={Link}
                    to="/uploads"
                    label={
                        <Grid
                            container
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '20px' }}
                        >
                            <img src={check} alt='social-campaign' style={{ width: '24px', height: '24px', flexShrink: 0 }} />
                            <span style={{ color: 'white', textTransform: 'none' }}>Uploads</span>
                        </Grid>
                    }
                    value={8}
                    onClick={() => setSelectedTab(8)}
                    style={{
                        marginTop: '2px',
                        display: 'flex',
                        alignItems: 'center',
                        textDecoration: 'none',
                        position: 'relative',
                        backgroundColor: selectedTab === 8 ? 'black' : '',
                        textTransform: 'none',
                        width: '200px',
                        height: '50px',
                        paddingLeft: '30px'
                    }}
                />
                }
             
               
                {!isSmallScreen && (
                    (departmentName === 'Franchisee' && agentRole.includes(2)) ||
                    [1, 3].some(role => agentRole.includes(role))
                ) && (<Tab
                    component={Link}
                    to="/franchiseDashboard"
                    label={
                        <Grid
                            container
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '20px' }}
                        >
                            <img src={check} alt='franchisedashboard' style={{ width: '24px', height: '24px', flexShrink: 0 }} />
                            <span style={{ color: 'white', textTransform: 'none' }}>Sales Dashboard</span>
                        </Grid>
                    }
                    value={10} // srini - 21/11/24
                    onClick={() => setSelectedTab(10)}
                    style={{
                        marginTop: '2px',
                        display: 'flex',
                        alignItems: 'center',
                        textDecoration: 'none',
                        position: 'relative',
                        backgroundColor: selectedTab === 10 ? 'black' : '',
                        textTransform: 'none',
                        width: '200px',
                        height: '50px',
                        paddingLeft: '30px'
                    }}
                />)}
              
                {!isSmallScreen && (<Tab
                    component={Link}
                    to="/learningCentre"
                    label={
                        <Grid
                            container
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '20px' }}
                        >
                            <img src={check} alt='franchisedashboard' style={{ width: '24px', height: '24px', flexShrink: 0 }} />
                            <span style={{ color: 'white', textTransform: 'none' }}>Learning Centre</span>
                        </Grid>
                    }
                    value={11}
                    onClick={() => setSelectedTab(11)}
                    style={{
                        marginTop: '2px',
                        display: 'flex',
                        alignItems: 'center',
                        textDecoration: 'none',
                        position: 'relative',
                        backgroundColor: selectedTab === 11 ? 'black' : '',
                        textTransform: 'none',
                        width: '200px',
                        height: '50px',
                        paddingLeft: '30px'
                    }}
                />)}
                
               

              
                {!isSmallScreen && (<Tab
                    component={Link}
                    to="/engagement"
                    label={
                        <Grid
                            container
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '20px' }}
                        >
                            <img src={check} alt='dashboard' style={{ width: '24px', height: '24px', flexShrink: 0 }} />
                            <span style={{ color: 'white', textTransform: 'none' }}>Engagement</span>
                        </Grid>
                    }
                    value={13}
                    onClick={() => setSelectedTab(13)}
                    style={{
                        marginTop: '2px',
                        display: 'flex',
                        alignItems: 'center',
                        textDecoration: 'none',
                        position: 'relative',
                        backgroundColor: selectedTab === 13 ? 'black' : '',
                        textTransform: 'none',
                        width: '200px',
                        height: '50px',
                        paddingLeft: '30px'
                    }}

                />)}
                 

                 {!isSmallScreen && (([2].some(role => agentRole.includes(role)) && agentMenu.includes(11)) || agentRole.includes(3)) && (<Tab
                    component={Link}
                    to="/wealth_vault"
                    label={
                        <Grid
                            container
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '20px' }}
                        >
                            <img src={check} alt='dashboard' style={{ width: '24px', height: '24px', flexShrink: 0 }} />
                            <span style={{ color: 'white', textTransform: 'none' }}>Wealth Vault</span>
                        </Grid>
                    }
                    value={14}
                    onClick={() => setSelectedTab(14)}
                    style={{
                        marginTop: '2px',
                        display: 'flex',
                        alignItems: 'center',
                        textDecoration: 'none',
                        position: 'relative',
                        backgroundColor: selectedTab === 14 ? 'black' : '',
                        textTransform: 'none',
                        width: '200px',
                        height: '50px',
                        paddingLeft: '30px'
                    }}

                />)}
                */}


                {(!isSmallScreen && user_data?.roles?.[0]?.menus?.some(menu => menu.name === 'Research') || !isSmallScreen && user_data?.additionalMenu?.some(menu => menu.name === 'Research') ) && (<Tab
                    component={Link}
                    to="/research"
                    label={
                        <Grid
                            container
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '20px' }}
                        >
                            <img src={check} alt='dashboard' style={{ width: '24px', height: '24px', flexShrink: 0 }} />
                            <span style={{ color: 'white', textTransform: 'none' }}>Research</span>
                        </Grid>
                    }
                    value={9}
                    onClick={() => setSelectedTab(9)}
                    style={{
                        marginTop: '2px',
                        display: 'flex',
                        alignItems: 'center',
                        textDecoration: 'none',
                        position: 'relative',
                        backgroundColor: selectedTab === 9 ? 'black' : '',
                        textTransform: 'none',
                        width: '200px',
                        height: '50px',
                        paddingLeft: '30px'
                    }}
                />)} 
                {(!isSmallScreen && user_data?.roles?.[0]?.menus?.some(menu => menu.name === 'Faqs') || !isSmallScreen && user_data?.additionalMenu?.some(menu => menu.name === 'Faqs')) &&  (<Tab
                    component={Link}
                    to="/faqs"
                    label={
                        <Grid
                            container
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '20px' }}
                        >
                            <img src={check} alt='dashboard' style={{ width: '24px', height: '24px', flexShrink: 0 }} />
                            <span style={{ color: 'white', textTransform: 'none' }}>FAQs</span>
                        </Grid>
                    }
                    value={15}
                    onClick={() => setSelectedTab(15)}
                    style={{
                        marginTop: '2px',
                        display: 'flex',
                        alignItems: 'center',
                        textDecoration: 'none',
                        position: 'relative',
                        backgroundColor: selectedTab === 15 ? 'black' : '',
                        textTransform: 'none',
                        width: '200px',
                        height: '50px',
                        paddingLeft: '30px'
                    }}
                />)} 

                {(!isSmallScreen && user_data?.roles?.[0]?.menus?.some(menu => menu.name === 'Operations') || !isSmallScreen && user_data?.additionalMenu?.some(menu => menu.name === 'Operations')) && (<Tab
                    component={Link}
                    to="/operations"
                    label={
                        <Grid
                            container
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '20px' }}
                        >
                            <img src={check} alt='franchisedashboard' style={{ width: '24px', height: '24px', flexShrink: 0 }} />
                            <span style={{ color: 'white', textTransform: 'none' }}>Operations</span>
                        </Grid>
                    }
                    value={7}
                    onClick={() => setSelectedTab(7)}
                    style={{
                        marginTop: '2px',
                        display: 'flex',
                        alignItems: 'center',
                        textDecoration: 'none',
                        position: 'relative',
                        backgroundColor: selectedTab === 7 ? 'black' : '',
                        textTransform: 'none',
                        width: '200px',
                        height: '50px',
                        paddingLeft: '30px'
                    }}
                />)}

            </Tabs>
        </Grid>
    )
}

export default withStyles(styles)(ListTabs)